module.exports = __webpack_public_path__ + "assets/img/jcptzy.0edb06c8.png";